import React from 'react';
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
const RegionContext = createContext(null);
const STORAGE_KEY = 'app:region';

export const DEFAULT_COUNTRY = {
  code: 'US',
  name: 'United States',
  flag: '🇺🇸',
  currency: 'USD',
  dial: '+1',
  language: 'en',
};
const readCountryFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : DEFAULT_COUNTRY;
  } catch {
    return DEFAULT_COUNTRY;
  }
};

const writeCountryToStorage = (country) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(country));
  } catch {
    console.warn('LocationContext: failed to persist country to localStorage');
  }
};
export const RegionProvider = ({ children }) => {
  const [country, setCountryState] = useState(readCountryFromStorage);
  const setCountry = useCallback((selected) => {
    setCountryState(selected);
    writeCountryToStorage(selected);
  }, []);

  return (
    <RegionContext.Provider value={{ country, setCountry }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);
